import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-meet-vibes-edit',
  templateUrl: './meet-vibes-edit.component.html',
  styleUrls: ['./meet-vibes-edit.component.css']
})
export class MeetVibesEditComponent implements OnInit {
  meetVibesEditForm!:FormGroup;
  submitted: any;
  token: any;
  id:any;
  meetVibesData:any
  image: any;
  imageSrc: any;
  fileName!: string;


  constructor(public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder : FormBuilder
    ) { }

  ngOnInit(): void {
    this.id = this.activateroute.snapshot.paramMap.get('id');
    this.meetVibesEditForm = this.formBuilder.group({
      name: ['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      image:['']
      });
    this.geteditData()
  }

  get editForm() {return this.meetVibesEditForm.controls;}

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.image = file;
      this.fileName =  file.name
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageSrc = event.target.result;
    };
    reader.readAsDataURL(file);
  }

  geteditData(){
    let obj = {
      food_preference_id : this.id
    };
    this.token = localStorage['token'];
    this.prefrencesService.getMeetVibesDetails(obj, this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.meetVibesData = res.data;
        this.meetVibesEditForm.patchValue({
          name:this.meetVibesData.name,
        });
        const imageName=this.meetVibesData.image.split('/')
        this.fileName=imageName[imageName?.length - 1]
        this.image = this.meetVibesData.image;
        this.meetVibesEditForm.value.image = this.image;
        if (this.image) {
          this.imageSrc = this.image;  // Assuming image is a URL or base64 data
        }
        // this.toastr.success(res.message);
      }
      else{
        // this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  onSubmit(){
    this.submitted = true;
    if (this.meetVibesEditForm.invalid) {
      return;
    }
    this.token = localStorage['token'];
    let formData = new FormData()
    formData.append('name',this.meetVibesEditForm.get('name')?.value)
    formData.append('image',this.image)
    formData.append('id',this.id)

    this.prefrencesService.editMeetVibes(formData,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toastr.success(res.message);
        this.router.navigate(['/meet-vibes-list']);
        this.meetVibesEditForm.reset();
        this.submitted = false;
      }
    });
  }

}
